import React from 'react';
import {CheckRounded} from '@mui/icons-material';

const ResourceCard = ({resource, checked, onChange}) => {
    const handleClick = () => onChange(!checked);

    const handleKeyDown = (e) => {
        if (e.key === ' ' || e.key === 'Enter') {
            e.preventDefault();
            onChange(!checked);
        }
    };

    return (
        <div
            role="checkbox"
            aria-checked={checked}
            aria-label={resource.label}
            tabIndex={0}
            onClick={handleClick}
            onKeyDown={handleKeyDown}
            className={`ch-lesson-planner-resource-card${checked ? ' ch-lesson-planner-resource-card--checked' : ''}`}
        >
            <span className="ch-lesson-planner-resource-card-icon" aria-hidden="true">
                {resource.icon}
            </span>
            <div className="ch-lesson-planner-resource-card-body">
                <span className="ch-lesson-planner-resource-card-label">{resource.label}</span>
                <span className="ch-lesson-planner-resource-card-description">{resource.description}</span>
            </div>
            <div className="ch-lesson-planner-resource-card-check" aria-hidden="true">
                {checked && <CheckRounded fontSize="small" />}
            </div>
        </div>
    );
};

export default ResourceCard;
